import { Client } from "@microsoft/microsoft-graph-client";
import { AuthCodeMSALBrowserAuthenticationProvider } from "@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser";

export class GraphService {
  constructor(msalInstance) {
    const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
      msalInstance,
      {
        account: msalInstance.getActiveAccount(),
        scopes: [
          "User.Read",
          "User.ReadBasic.All",
          "People.Read",
          "Contacts.Read",
        ],
        interactionType: "redirect",
      }
    );

    this.client = Client.initWithMiddleware({
      authProvider,
    });
  }

  async getUserInfo() {
    try {
      return await this.client.api("/me").get();
    } catch (error) {
      console.error("Error getting user info:", error);
      throw error;
    }
  }

  async getUserPhoto() {
    try {
      const response = await this.client.api("/me/photo/$value").get();
      return URL.createObjectURL(response);
    } catch (error) {
      console.error("Error getting user photo:", error);
      return null;
    }
  }

  async getContacts() {
    try {
      const response = await this.client.api("/me/contacts").get();
      return response.value;
    } catch (error) {
      console.error("Error getting contacts:", error);
      return [];
    }
  }
}
